module.exports = {
      id: "twitter-icon-usage",
      viewBox: "0 0 135.08 135.08",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#twitter-icon",
      toString: function () {
        return this.url;
      }
    }